import * as Sentry from '@sentry/react';

const mode = (import.meta.env.MODE || 'development').toLowerCase();
const appEnvironment = (import.meta.env.REACT_APP_ENVIRONMENT || 'development').toLowerCase();
const isLocalLikeEnvironment = import.meta.env.DEV
  || ['local', 'development', 'develop', 'dev', 'test'].includes(mode)
  || ['local', 'development', 'develop', 'dev', 'test'].includes(appEnvironment);

// Single source of truth for whether Sentry is active: only outside local-like
// environments and only when a DSN is configured. Used by both initialization
// (instrument.ts) and the ErrorBoundary fallback so they can never disagree.
export const sentryEnabled = !isLocalLikeEnvironment && Boolean(import.meta.env.REACT_APP_SENTRY_DSN);

const parseSampleRate = (rawValue: string | undefined, fallback: number): number => {
  if (!rawValue) {
    return fallback;
  }

  const parsed = Number.parseFloat(rawValue);
  return Number.isFinite(parsed) && parsed >= 0 && parsed <= 1 ? parsed : fallback;
};

export const initializeSentry = (): void => {
  if (!sentryEnabled) {
    return;
  }

  Sentry.init({
    dsn: import.meta.env.REACT_APP_SENTRY_DSN,
    environment: import.meta.env.REACT_APP_ENVIRONMENT || import.meta.env.MODE,
    tracesSampleRate: parseSampleRate(import.meta.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE, 0),
    sendDefaultPii: import.meta.env.REACT_APP_SENTRY_SEND_DEFAULT_PII === 'true',
  });
};
